export default __webpack_public_path__ + "static/media/mw10.eba33575.webp";